export default {
  listaAgendas: [],
}
